
import { defineComponent, ref } from 'vue'
import { axios } from '@/plugins/axios'
import { useRoute } from 'vue-router'
import { useStore } from '@/store/index'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { useI18n } from 'vue-i18n'
import { ALERT_COLORS } from '@/store/base'

import BaseAvatar from '@/components/BaseAvatar.vue'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'

export default defineComponent({
  components: { BaseAvatar, BaseFormSubmit },
  setup() {
    const route = useRoute()
    const { t } = useI18n()
    const store = useStore()
    const btnDisabled = ref(false)
    const dialogVisible = ref(false)

    const schema = yup.object({
      message: yup.string().required().max(5000),
    })

    const { handleSubmit, errors, resetForm } = useForm({ validationSchema: schema })

    const { value: message } = useField<string>('message')

    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post(`/video/question/${route.params.video_id}`, values)
        .then(response => {
          store.commit('video/setVideoDetails', response.data.payload)
          store.commit('base/setAlertMessages', { messages: [t('video_details.complete')], color: ALERT_COLORS.info })
          resetForm()
        })
        .finally(() => {
          btnDisabled.value = false
          dialogVisible.value = false
        })
    })

    const onDialog = handleSubmit(values => {
      dialogVisible.value = true
    })

    return {
      t,
      errors,
      message,
      onSubmit,
      onDialog,
      btnDisabled,
      dialogVisible
    }
  },
})
